import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginPage } from './pages/login/login.component';
import { UiModule } from '../ui/ui.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthPage } from './pages/auth/auth.component';
import {UtilsModule} from "../utils/utils.module";



@NgModule({
  declarations: [LoginPage, AuthPage],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    UtilsModule,
    UiModule,
  ]
})
export class AuthModule { }
